import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Input, Table, ModalFooter, Button, FormGroup, Label } from "reactstrap";
import { Organisation } from "../../interfaces/models/Organisation";

interface Props {
    organisations : Organisation[];
    selectedOrgs : string[];
    isButtonDisabled : boolean;
    handleSave : (selected : string[]) => Promise<void>;
    modalOpen : boolean;
    toggleModal : () => void; 
}

export default function OrganisationSelectorModal({ organisations, isButtonDisabled, handleSave, modalOpen, toggleModal, selectedOrgs } : Props) {

    const [organisationsFiltered, setOrganisationsFiltered] = useState<Organisation[]>([]);
    const [selectedOrganisations, setSelectedOrganisations] = useState<string[]>([]);

    useEffect(() => {
        setOrganisationsFiltered(organisations);
    },[organisations]);
    
    useEffect(() => {
        setSelectedOrganisations(selectedOrgs);
    },[selectedOrgs]);

    const FilterOrganisation = (e : React.KeyboardEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value?.toLowerCase().trim();
        if(!value) {
            setOrganisationsFiltered(organisations);
            return;
        }

        setOrganisationsFiltered(organisations.filter(u => u.name.toLowerCase().includes(value)))
    }

    const OnOrganisationCheckboxChanged = (e : React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;
        let selected = [...selectedOrganisations];
        if (checked) {
            if(selected.indexOf(value) === -1) {
                selected.push(value);
            } 
        } 
        else {
            const getIndex = selected.indexOf(value);
            if(getIndex > -1) {
                selected.splice(getIndex, 1);
            } 
        }
        setSelectedOrganisations(selected);

    }

    const HandleToggleAll = (e : React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.checked) {
            setSelectedOrganisations(organisations.map(u => u._id));
        } else {
            setSelectedOrganisations([]);
        }
    }

    const HandleSaveOrganisation = async () => {
        await handleSave(selectedOrganisations);
    }

    return (
        <Modal
            id="challenge-organisation-setup-modal"
            backdrop={true}
            isOpen={modalOpen}>
            <ModalHeader toggle={toggleModal} className="pb-0">
                <p className="text-lg">Select Organisation</p>
            </ModalHeader>
            <ModalBody>
                <div className="d-flex ">
                    <label className="mt-2 mr-2">Search: </label>
                    <Input className="w-100" type="text" onKeyUp={(e) => { FilterOrganisation(e); }} placeholder="Search Organisation here" />
                </div>
                <div className="pt-2 border-right border-left border-top mt-2">
                    <FormGroup check className="mb-2 border-bottom  pb-2">
                        <Label check className="d-flex align-items-center ml-4">
                        <Input
                            type="checkbox"
                            style={{ transform: "scale(1.5)" }}
                            className="mb-1 "
                            onChange={HandleToggleAll}
                        />
                        <strong>Select All</strong>
                        </Label>
                    </FormGroup>

                    {organisationsFiltered.length === 0 && (
                        <div className="text-center text-muted border-bottom pb-2">
                            No Organisation Found
                        </div>
                    )}

                    {organisationsFiltered.map((item) => (
                        <FormGroup check key={item._id} className="mb-2 border-bottom pb-2 ">
                                <Label check className="d-flex align-items-center ml-4">
                                <Input
                                    style={{ transform: "scale(1.5)" }}
                                    className="mb-1"
                                    type="checkbox"
                                    value={item._id}
                                    checked={selectedOrganisations?.includes(item._id)}
                                    onChange={OnOrganisationCheckboxChanged}
                                />
                                <span className="ms-2">{item.name}</span>
                            </Label>
                        </FormGroup>
                    ))}

                </div>
            </ModalBody>
            <ModalFooter>
                <div className="">
                    <Button color="secondary" disabled={isButtonDisabled} onClick={toggleModal}>Cancel</Button>
                    <Button color="primary" disabled={isButtonDisabled} onClick={HandleSaveOrganisation}>Save</Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}